import commons from './commons';

export const environment = {
  ...commons,
  production: true,
};
